import React from 'react';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import ManageFileGroupingImportProcedureComponentVM from './ManageFileGroupingImportProcedureComponentVM';
import { NumberFormat } from '@singularsystems/neo-core/dist/NumberUtils';
import { ModalUtils, Validation } from '@singularsystems/neo-core';

interface IManageFileGroupingImportProcedureComponentProps {
    viewModel: ManageFileGroupingImportProcedureComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageFileGroupingImportProcedureComponent extends React.Component<IManageFileGroupingImportProcedureComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <div>
                {<Neo.Card title={TextConstants.Titles.ManageFileGroupingImportProcedure}>
                    <Neo.Form
                        model={viewModel.managedFileGroupingFileSpecImportProcedure}
                        validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                        onSubmit={() => this.props.onSave()}
                        onInvalid={this.onFormInvalid}>
                        <div>
                            <Neo.GridLayout lg={4}>
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.Broker}
                                    bindContext={viewModel.managedFileGroupingFileSpecImportProcedure.meta.stockbrokerName} >
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                        bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.staticServiceProviderFileGroupingId}
                                        bindDisplay={viewModel.managedFileGroupingFileSpecImportProcedure.meta.stockbrokerName}
                                        displayMember={"serviceProviderGroupingName"}
                                        disabled={true}
                                        isReadOnly={viewModel.isReadOnly}
                                        items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                                    />
                                </Neo.FormGroup>
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.FileType}
                                    disabled={true} 
                                    bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.fileType} 
                                    isReadOnly={viewModel.isReadOnly} />
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.ActiveStartDate}
                                    display={viewModel.managedFileGroupingFileSpecImportProcedure.meta.activeStartDate} />
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.ActiveEndDate}
                                    display={viewModel.managedFileGroupingFileSpecImportProcedure.meta.activeEndDate} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={2}>
                                <Neo.GridLayout lg={2}>
                                    <Neo.FormGroup
                                        isReadOnly={viewModel.isReadOnly}
                                        label={TextConstants.Labels.Process}
                                        bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.processTypeID}
                                        select={{
                                            items: viewModel.processTypeList,
                                            displayMember: "process",
                                            valueMember: "processTypeID",
                                            allowNulls: false
                                        }}
                                        onChange={() => viewModel.setSelectedProcess()} />
                                    <div>
                                        <Neo.FormGroup
                                            label={TextConstants.Labels.ProcessPriority}
                                            bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.priority}
                                            numProps={{ format: NumberFormat.NoDecimals }} />
                                    </div>
                                </Neo.GridLayout>
                                <Neo.FormGroup
                                    isDisabled={viewModel.disabled}
                                    label={TextConstants.Labels.StoredProcedure}
                                    bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.importProcedureId}
                                    select={{
                                        items: viewModel.importProcedureList,
                                        displayMember: "storedProcedure",
                                        valueMember: "importProcedureId",
                                        allowNulls: false
                                    }} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={1}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.FilterClause}
                                    bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.filterClause}
                                    input={{ rows: 3 }} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={1}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.JoinClause}
                                    bind={viewModel.managedFileGroupingFileSpecImportProcedure.meta.joinClause}
                                    input={{ rows: 3 }} />
                            </Neo.GridLayout>
                        </div>
                        <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                    </Neo.Form>
                </Neo.Card>}
            </div>
        );
    }
    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidFileImportProcedureConfiguration);
        }
    }
}